<template>
  <div class="content-box">
    <ModelInfo v-if="photoDetails.album.modelsOfAlbum && photoDetails.album.modelsOfAlbum.length" :info="photoDetails.album.modelsOfAlbum[0].basic"
               :labels="photoDetails.album.labels"/>
    <h3 class="article title">{{ photoDetails.album.title }}</h3>
    <p class="article intro">{{  photoDetails.album.introduction }}</p>
    <img class="article photo" v-for="(item, index) in photoDetails.album.photos"
         v-if="index < 3"
         :src="item.url"
         :key="item.id" />
    <TextBar :text="photoDetails.textBar" />
    <section >
      <Title :title="'最新专辑'" />
      <article class="list-box">
        <Gallery v-for="item in photoDetail.newAlumList" :source="'newAlbum'" :gallery="item.album" :key="item.id" />
      </article>
    </section>
  </div>
</template>

<script>
  import ModelInfo from '@/components/ModelInfo'
  import TextBar from '@/components/TextBar'
  import Gallery from '@/components/GalleryM'
  import Title from '@/components/TitleM'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      ModelInfo,
      TextBar,
      Gallery,
      Title
    },

    // 服务器端渲染，预加载专辑详情数据
    asyncData ({ store, route }) {
      const id = route.params.contentId;
      return store.dispatch('getDetailById', id)
    },
    computed: {
      ...mapGetters({
        photoDetail: 'photoDetail'
      }),
      // 处理专辑详情数据
      photoDetails () {
        const album = this.photoDetail.detail.album;
        const { prevId, prevTitle, nextId, nextTitle } = this.photoDetail.detail;
        const data = { album, textBar: { prevId, prevTitle, nextId, nextTitle }};

        return data
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .content-box {
    margin-top: px2rem(10px);
    background-color: #fff;
    .title { text-align: center }
    .article { padding: 0 10px }
    .intro { margin-bottom: px2rem(10px) }
    .photo {
      width: calc(100% - 20px);
      margin: auto 0;
      border-radius: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/PhotoDetail.vue